import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { flag_01 } from "@tql/ui-components-react/untitled/icons";
import type { ReactNode } from "react";
import { useContext } from "react";

import { QuoteDetailsContext } from "~/features/quote/context/quote-details-context.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

import styles from "./template-actions.module.css";

type TemplateActionsProps = Readonly<{
	onClearTemplate: () => void;
	onToggleTemplatesModal: () => void;
	simulateMode: boolean;
	templateMode: boolean;
}>;

export function TemplateActions({
	onClearTemplate,
	onToggleTemplatesModal,
	simulateMode,
	templateMode,
}: TemplateActionsProps) {
	const { isReady: isTemplatesReady, isEnabled: isTemplatesEnabled } =
		useFeatureFlagGate("traxLtlTemplatesPage");
	const { quoteState } = useContext(QuoteDetailsContext);

	const customerHasId = Boolean(quoteState?.customer?.id);
	const hasAppliedTemplate = Boolean(quoteState.templateId);
	const templateName = quoteState.templateName;

	if (!isTemplatesReady || !isTemplatesEnabled) {
		return null;
	}

	const templateIndicatorContent: ReactNode = hasAppliedTemplate ? (
		<div className={styles.templateIndicatorText}>
			<div className={styles.templateIndicatorLabel}>
				Template Applied:&nbsp;
			</div>
			<div
				className={styles.templateIndicatorName}
				title={String(templateName ?? "")}
			>
				{String(templateName ?? "")}
			</div>
			<div className={styles.templateIndicatorIcon}>
				&nbsp;
				<SvgIcon icon={flag_01} />
			</div>
		</div>
	) : (
		"No Template Currently Applied"
	);

	return (
		<div className={styles.templateIndicatorWrapper}>
			{templateMode || simulateMode ? null : (
				<div className={styles.templateIndicatorContentWrapper}>
					{templateIndicatorContent}
				</div>
			)}
			{templateMode || simulateMode ? null : (
				<div className={styles.templateIndicatorButtons}>
					<Button
						disabled={!customerHasId}
						onClick={onToggleTemplatesModal}
						tabIndex={-1}
					>
						My Templates
					</Button>
					{hasAppliedTemplate ? (
						<Button
							onClick={onClearTemplate}
							tabIndex={-1}
							variant={"secondary"}
						>
							Clear Template
						</Button>
					) : null}
				</div>
			)}
		</div>
	);
}
